/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Actions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import ThreeDotsMenu from 'DesignSystem/ThreeDotsMenu/index'



/** @type {import('Simple/types.js').View} */
export default function Actions({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/Phones/Content/Phone/Actions"
  
}) {
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<ThreeDotsMenu
  viewPath={`${viewPath}/ThreeDotsMenu`}
 fill={dtColorsGreen700}
 onClick={onClick}
 data="options"
 from={optionsValueData}
 paddingTop={0}
 paddingLeft={0}
 paddingBottom={0}
 paddingRight={0}
 marginLeft={dtSpaceXxs}
 left="-150px"
 height="auto"
 width={230}
 valueWidth="auto"
 selectedBackgroundColor="transparent"
 alignSelf="center"
/>
{children}
</React.Fragment>)
}